/**
 * @license
 * Copyright Tyler Technologies, Inc. 
 * License: Apache-2.0
 */
export class DateRange {
    constructor(range) {
        if (range) {
            this.from = range.from ? new Date(range.from) : undefined;
            this.to = range.to ? new Date(range.to) : undefined;
        }
    }
    copy() {
        return new DateRange(this);
    }
}
